import { IntervalTexts } from '../../utils/metric';

export const GET_OKR_TAB = 'GET_OKR_TAB';
export const SET_OKR_TAB = 'SET_OKR_TAB';
export const DISABLE_MODAL = 'DISABLE_MODAL';
export const GET_GOAL_METRIC = 'GET_GOAL_METRIC';
export const SELECTED_METRIC = 'SELECTED_METRIC';
export const METRIC_GRAPH_DATA = 'METRIC_GRAPH_DATA';
export const AFTER_METRIC_CONFIDENCE = 'AFTER_METRIC_CONFIDENCE';

export const metricdetailConstants = {
    // kr source types
    SOURCE_PERSON: 1,
    SOURCE_WORKSTREAM: 2,
    SOURCE_METRICS: 3,
    SOURCE_AVG_CYCLE_TIME: 4,
    SOURCE_SURVEY: 5,
    SOURCE_OUTSIDE_WORKBOARD: 6,
    SOURCE_OTHER_GOALS: 7,
    SOURCE_EXT_SOURCES: 8,
    SOURCE_CASCADE_RESULTS: 9, // only for UI, not using in db
    SOURCE_DATA_STREAMS: 10,
    SOURCE_MIRROR_KR: 11,
    SOURCE_MIT_PERSON: 12,
    SOURCE_MIT_DATA_STREAMS: 13,
    SOURCE_MIT_PERSON_DISTINCT: 14,

    TYPE_REGULAR: 1,
    TYPE_CASCADE: 2,

    JIRA_ID: 5,
    ASANA_ID: 6,
    MS_PLANNER_ID: 11,
    AZURE_CLOUD_ID: 13,
    IFRAME_HOSTED_EXT_SOURCE_ID: 15,

    // kr graph types
    PIE_CHART: 1,
    BAR_CHART: 2,
    LINE_CHART: 3,
    STACKED_BAR_CHART: 5,
    RANGE_CHART: 6,
    THRESHOLD_CHART: 7,

    // kr interval
    INTERVAL_DAY: 1,
    INTERVAL_WEEK: 2,
    INTERVAL_MONTH: 3,
    INTERVAL_QUARTER: 4,
    INTERVAL_ONCE: 5,
    INTERVAL_BIWEEKLY: 6,
    INTERVAL_BIQUATERLY: 7,
    INTERVAL_TRIMESTER: 8,
    // kr counting
    METRIC_COUNTING_UP: 1,
    METRIC_COUNTING_DOWN: 2,
    METRIC_COUNTING_THRESHOLD: 3,
    METRIC_COUNTING_RANGE: 4,
    METRIC_COUNTING_SURVEY_YES_NO: 5,
    METRIC_COUNTING_SURVEY_SCALE: 6,

    // kr metric
    METRIC_NUMBER: 1,
    METRIC_DOLLAR: 2,
    METRIC_PERCENTAGE: 3,
    METRIC_AVG_CYCLE_TIME: 4,

    // kr progress type
    PROGRESS_TYPE_LAST_UPDATE: 1,
    PROGRESS_TYPE_TOTAL: 2,
    PROGRESS_TYPE_AVERAGE: 3,
    PROGRESS_TYPE_SUM_LAST_UPDATE: 4,

    // goal status
    GOAL_ACTIVE: 1,
    GOAL_DELETED: 0,
    GOAL_CLOSED: 2,

    METRIC_CLOSED: 2
}

export const METRIC_SOURCE = {
    SOURCE_PERSON: 1,
    SOURCE_WORKSTREAM: 2,
    SOURCE_METRICS: 3,
    SOURCE_AVG_CYCLE_TIME: 4,
    SOURCE_SURVEY: 5,
    SOURCE_OUTSIDE_WORKBOARD: 6,
    SOURCE_OTHER_GOALS: 7,
    SOURCE_EXT_SOURCES: 8,
    SOURCE_CASCADE_RESULTS: 9,
    SOURCE_DATA_STREAMS: 10,
    SOURCE_MIRROR_KR: 11,
    SOURCE_MIT_PERSON: 12,
    SOURCE_MIT_DATA_STREAMS: 13,
}

export const METRIC_COUNTING = {
    METRIC_COUNTING_UP: 1,
    METRIC_COUNTING_DOWN: 2,
    METRIC_COUNTING_THRESHOLD: 3,
    METRIC_COUNTING_RANGE: 4,
    METRIC_COUNTING_SURVEY_YES_NO: 5,
    METRIC_COUNTING_SURVEY_SCALE: 6,
}

export const METRIC_TYPE = {
    TYPE_REGULAR: 1,
    TYPE_CASCADE: 2,
}

export const CHART_TYPE = {
    // kr graph types
    PIE_CHART: 1,
    BAR_CHART: 2,
    LINE_CHART: 3,
    STACKED_BAR_CHART: 5,
    RANGE_CHART: 6,
    THRESHOLD_CHART: 7,
}

export const KRDETAILSMETRICCONST = IntervalTexts;

/**
 * Value for history.state.source when the popstate was triggered by closing the OKR popup.
 * Used to distinguish OKR popup-close navigation from other custom router state changes.
 */
export const OKR_POPUP_CLOSE_HISTORY_STATE_SOURCE = 'okr_popup_close';

/**
 * Pages where refresh and scroll restoration should be skipped when OKR popup closes.
 * Add pathname patterns here that should not refresh or scroll when OKR popup closes.
 * This list is shared between:
 * - wb/js/workboard.js (refresh prevention)
 * - wb/wobo-frontend/src/okr/modals/okr_popup/okr_header/okrHeaderKebab.tsx (scroll prevention)
 */
export const PAGES_TO_SKIP_REFRESH_AND_SCROLL_ON_OKR_POPUP_CLOSE = [
  'activity/workstreams',
  'goal/goalAlign',
  // Add more pathname patterns here as needed
];

// Export to window for legacy JS code to access
if (typeof window !== 'undefined') {
  (window as any).PAGES_TO_SKIP_REFRESH_AND_SCROLL_ON_OKR_POPUP_CLOSE = PAGES_TO_SKIP_REFRESH_AND_SCROLL_ON_OKR_POPUP_CLOSE;
  (window as any).OKR_POPUP_CLOSE_HISTORY_STATE_SOURCE = OKR_POPUP_CLOSE_HISTORY_STATE_SOURCE;
}
